"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BaseRadioButton = BaseRadioButton;

var _fieldsStyledComponents = require("./forms/fields-styled-components");

var _media = require("react-components/media");

var _typography = require("./typography");

var _styles = require("react-components/styles");

var _styledTools = require("styled-tools");

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _v = _interopRequireDefault(require("uuid/v1"));

var _excluded = ["className", "disabled", "hasError", "inline", "label"];

var _templateObject;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var checkedIcon = "<svg xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 24 24\"><g stroke-width=\"2\"><circle class=\"radio-icon-stroke-color\" cx=\"12\" cy=\"12.006\" r=\"11\"/><circle class=\"radio-icon-fill-color\" cx=\"12\" cy=\"12.006\" r=\"9\" stroke=\"currentColor\"/><path fill=\"currentColor\" d=\"M11.99 17.006a5 5 0 100-10 5 5 0 000 10z\"/></g></svg>";
var uncheckedIcon = "<svg xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 24 24\"><g stroke-width=\"2\"><circle class=\"radio-icon-stroke-color\" cx=\"12\" cy=\"12.006\" r=\"11\"/><circle cx=\"12\" cy=\"12.006\" r=\"9\" stroke=\"currentColor\"/></g></svg>";

/**
 * `StyledFormGroup` styled component.
 */
var StyledFormGroup = (0, _styledComponents["default"])(_fieldsStyledComponents.FormGroup).withConfig({
  displayName: "radio-button__StyledFormGroup",
  componentId: "sc-iu8uo1-0"
})(["", ""], (0, _styledTools.ifProp)('inline', (0, _styledComponents.css)(["display:inline-block;margin-right:16px;"])));
/**
 * `StyledIcon` styled component.
 */

var StyledIcon = (0, _styledComponents["default"])(_media.Icon).withConfig({
  displayName: "radio-button__StyledIcon",
  componentId: "sc-iu8uo1-1"
})(["left:0;max-width:24px;position:absolute;top:-2px;transition:opacity ", ";width:24px;", ""], (0, _styledTools.theme)('animations.defaultTransition'), _styles.media.min('md')(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    top: -1px;\n  "]))));
/**
 * `CheckedIcon` styled component.
 */

var CheckedIcon = (0, _styledComponents["default"])(StyledIcon).attrs({
  icon: checkedIcon
}).withConfig({
  displayName: "radio-button__CheckedIcon",
  componentId: "sc-iu8uo1-2"
})(["color:", ";opacity:0;", ""], (0, _styles.color)('primary'), (0, _styledTools.ifProp)('disabled', (0, _styledComponents.css)(["color:", ";"], (0, _styles.color)('gray300'))));
/**
 * `UncheckedIcon` styled component.
 */

var UncheckedIcon = (0, _styledComponents["default"])(StyledIcon).attrs({
  icon: uncheckedIcon
}).withConfig({
  displayName: "radio-button__UncheckedIcon",
  componentId: "sc-iu8uo1-3"
})(["color:", ";", ""], (0, _styles.color)('gray500'), (0, _styledTools.ifProp)('disabled', (0, _styledComponents.css)(["color:", ";"], (0, _styles.color)('gray300'))));
/**
 * `Label` styled component.
 */

var Label = (0, _styledComponents["default"])(_typography.Text).attrs({
  as: 'label'
}).withConfig({
  displayName: "radio-button__Label",
  componentId: "sc-iu8uo1-4"
})(["", " color:", ";cursor:pointer;display:block;padding-left:32px;position:relative;", " ", ""], _fieldsStyledComponents.textDesktopStyle, (0, _styles.color)('secondary'), (0, _styledTools.ifProp)('hasError', (0, _styledComponents.css)(["color:", ";"], (0, _styles.color)('danger'))), (0, _styledTools.ifProp)('disabled', (0, _styledComponents.css)(["color:", ";"], (0, _styles.color)('gray400'))));
/**
 * `Input` styled component.
 */

var Input = _styledComponents["default"].input.withConfig({
  displayName: "radio-button__Input",
  componentId: "sc-iu8uo1-5"
})(["left:0;opacity:0;position:absolute;&:checked + ", " ", "{opacity:1;}&:focus-visible + ", ":not(:hover){", ",", "{.radio-icon-stroke-color{stroke:", ";}}}&:not(:checked) + ", ":hover ", "{color:", ";}&:checked + ", ":hover ", "{.radio-icon-fill-color{fill:", ";}}&:checked + ", " ", ",&:checked + ", ":hover ", "{opacity:0;}"], Label, CheckedIcon, Label, UncheckedIcon, CheckedIcon, (0, _styles.color)('blue200'), Label, UncheckedIcon, (0, _styles.color)('gray600'), Label, CheckedIcon, (0, _styles.color)('blue200'), Label, UncheckedIcon, Label, UncheckedIcon);
/**
 * Export `BaseRadioButton` component.
 */


function BaseRadioButton(props) {
  var className = props.className,
      disabled = props.disabled,
      hasError = props.hasError,
      inline = props.inline,
      label = props.label,
      rest = _objectWithoutProperties(props, _excluded);

  var _useState = (0, _react.useState)(_v["default"]),
      _useState2 = _slicedToArray(_useState, 1),
      id = _useState2[0];

  return /*#__PURE__*/_react["default"].createElement(StyledFormGroup, {
    className: className,
    disabled: disabled,
    inline: inline
  }, /*#__PURE__*/_react["default"].createElement(Input, _extends({}, rest, {
    disabled: disabled,
    id: id,
    type: 'radio'
  })), /*#__PURE__*/_react["default"].createElement(Label, {
    disabled: disabled,
    hasError: hasError,
    htmlFor: id
  }, label, /*#__PURE__*/_react["default"].createElement(UncheckedIcon, {
    disabled: disabled
  }), /*#__PURE__*/_react["default"].createElement(CheckedIcon, {
    disabled: disabled
  })));
}